import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import React, { forwardRef } from 'react'

type Props = {
  className?: string
  label?: string | React.ReactNode
  name: string
  value?: string | number | null | any
  placeholder?: string
  maxLength?: number
  rows?: number
  optional?: boolean
} & React.ComponentPropsWithoutRef<'textarea'>

export const Textarea = forwardRef<HTMLInputElement, Props>((props: Props, ref: any) => {
  const { className, label, name, value, placeholder, maxLength, rows, optional, onChange, onBlur, onFocus } = props
  const errMsg = _.get(props, 'data-error')
  return (
    <div className='w-full form-error'>
      {
        label &&
        <label htmlFor={name} className='form-label'>
          {label}
          {
            optional &&
            <span className='font-light ml-1.5 text-zinc-600 dark:text-zinc-400'>(optional)</span>
          }
        </label>
      }
      <div className='relative form-container mt-1'>
        <textarea
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          id={name}
          name={name}
          value={value}
          placeholder={placeholder || ''}
          maxLength={maxLength || undefined}
          rows={rows || 4}
          className={twMerge('form-textarea resize-y rounded', className)}
        />
      </div>
      {
        errMsg && <div className='form-error-message'>{errMsg}</div>
      }
    </div>
  )
})

